export default __webpack_public_path__ + "static/lhp-6c9487b5bdffa65635c208cf17e5eee4.jpg";